import {otsBaseApi} from "../../ots-api";
import {OperatingArea} from "../../../model/operating-area";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["OperatingAreas"]});

const operatingAreaApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllOperatingAreas: builder.query<OperatingArea[], string | undefined>({
      query: (regionId) => ({
        url: `/operating-areas/all`,
        method: "GET",
        params: regionId ? {regionId: regionId} : undefined
      }),
      keepUnusedDataFor: 300,
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(({id}) => ({type: "OperatingAreas", id} as const)),
            {type: "OperatingAreas", id: "LIST"}
          ];
        } else {
          return [{type: "OperatingAreas", id: "LIST"}];
        }
      }
    }),
    getOperatingArea: builder.query<OperatingArea, string>({
      query: (id) => ({
        url: `/operating-areas/${id}`,
        method: "GET"
      }),
      keepUnusedDataFor: 300,
      providesTags: (result, error, id) => [{type: "OperatingAreas", id}]
    }),
    createOperatingArea: builder.mutation<OperatingArea, Partial<OperatingArea>>({
      query: (mapping) => ({
        url: '/operating-areas',
        method: 'POST',
        body: mapping,
      }),
      invalidatesTags: [{type: 'OperatingAreas', id: 'LIST'}],
    }),
    updateOperatingArea: builder.mutation<OperatingArea, Partial<OperatingArea>>({
      query: (mapping) => ({
        url: '/operating-areas',
        method: 'PUT',
        body: mapping,
      }),
      invalidatesTags: (result, error, {id}) => [{type: 'OperatingAreas', id}],
    }),
    deleteOperatingArea: builder.mutation<OperatingArea, Partial<OperatingArea>>({
      query: (mapping) => ({
        url: `/operating-areas`,
        method: 'DELETE',
        body: mapping,
      }),
      invalidatesTags: (result, error, {id}) => [{type: 'OperatingAreas', id}],
    }),
  })
});

export const {
  useGetAllOperatingAreasQuery,
  useGetOperatingAreaQuery,
  useCreateOperatingAreaMutation,
  useUpdateOperatingAreaMutation,
  useDeleteOperatingAreaMutation,
} = operatingAreaApi;
